import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import usePushForgotPassword from 'hooks/router/usePushForgotPassword';
import Link from './Link';

const ForgotPasswordLink = ({ onClick }) => {
  const { formatMessage } = useIntl();
  const pushForgotPassword = usePushForgotPassword();

  const handleOnClick = () => {
    pushForgotPassword();
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <Link onClick={handleOnClick}>
      {formatMessage({ id: 'page.login.link.forgotPassword' })}
    </Link>
  );
};

ForgotPasswordLink.propTypes = {
  onClick: PropTypes.func,
};

export default ForgotPasswordLink;
